import EconomicCalendarTable from "@/ui-components/economic-calendar-table";
import { CommonWidgetProps } from "../types";

function EconomicCalendar({ widgetCompositeId }: CommonWidgetProps) {
  return (
    <EconomicCalendarTable
      bodyRowClassNames="text-xs font-medium text-gray-900 dark:text-gray-100"
      widgetCompositeId={widgetCompositeId}
    />
  );
}

export default EconomicCalendar;
